module.exports = __webpack_public_path__ + "img/ppt-file.da5a39a4.svg";